import React from 'react';
import { Grid, Typography } from '@inplayer-org/inplayer-ui';
import { Field } from 'formik';
import styled from 'styled-components';

// hooks
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// utils
import { isDevelopmentEnv } from 'utils/helpers';

// constants
import Rules from 'restrictions/roles/constants/rules';

// components
import StyledContainer from 'components/StyledContainer';
import Select from 'components/Fields/Select';
import FieldError from 'components/Fields/FieldError';
import { DescriptionContainer } from 'pages/MerchantPages/Settings/Auth/GeoRestrictions/containers/GeoRestictions';
import AttentionMessage from 'components/AttentionMessage';

const { Cell } = Grid;

const StyledCell = styled(Cell)`
  height: fit-content;
`;

interface Props {
  age: number | string;
  isAgeRestrictionEnabled: boolean;
  isAssetRestriction?: boolean;
}

const options = [...Array(100)].map((_, i) => ({ value: i, displayName: `${i}+`, tag: i }));

const AgeRestrictionForm = ({ age, isAgeRestrictionEnabled, isAssetRestriction }: Props) => {
  const { hasRule } = useRestrictionRules();

  const isReadOnly = hasRule(Rules.READONLY_AGE_RESTRICTIONS);

  return (
    <>
      {!isAgeRestrictionEnabled ? (
        <Cell width={12}>
          <Typography variant="p">
            The age restriction functionality is currently not available for your account. Contact support at
            <a href="mailto:support@inplayer.com"> support@inplayer.com</a> to enable it.
          </Typography>
        </Cell>
      ) : (
        <StyledCell width={12}>
          {isDevelopmentEnv && <AttentionMessage />}
          <StyledContainer columns={12} margin="0.5rem 0 2rem 0">
            <Cell width={12}>
              <DescriptionContainer>
                <Typography variant="p">
                  {isAssetRestriction
                    ? 'Make your asset available only for certain ages. The restrictions set here will override the default restrictions set in the Settings.'
                    : 'Make your assets available only for certain ages. The restrictions set up here will only be applied to assets that do not have their own age restrictions.'}
                </Typography>
              </DescriptionContainer>
            </Cell>
            <Cell width={4}>
              <Field
                tag="dropdown_select_age"
                id="age_restriction"
                name="ageRestriction"
                component={Select}
                isInlineLabelField
                label="Select minimum age"
                // value={age}
                defaultOption={{ displayName: !isReadOnly ? 'Select age' : 'None selected' }}
                options={options}
                disabled={isReadOnly}
              />
              <FieldError name="ageRestriction" />
            </Cell>
          </StyledContainer>
        </StyledCell>
      )}
    </>
  );
};

export default AgeRestrictionForm;
